//
// Entry.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./AbstractEntry";
import "./EntryLayer";

var Entry = createModule("gtl::Entry", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::AbstractEntry"], EventDispatcher, [
    ,
    {
        layer: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Entry;
